<template>
  <b-container class="p-3">
    <b-row>
      <b-col>
        <b-button @click="showFormChangePassword">
          Change Password
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <b-button @click="showFormAltEmail">
          Add Alternative Email
        </b-button>
      </b-col>
    </b-row>

    <!-- modal -->
    <b-modal
      ref="pw-form"
      title="Change Password"
      hide-footer
    >
      <FormChangePassword :user="user" />
    </b-modal>
    <b-modal
      ref="ae-form"
      title="Add New Email"
      hide-footer
    >
      <FormAlternativeEmail :user="user" />
    </b-modal>
  </b-container>
</template>

<script>
// external dependencies

// custom component
import FormChangePassword from '@/templates/FormChangePassword'
import FormAlternativeEmail from '@/templates/FormAlternativeEmail'

// api call

export default {
  name: 'MyAccount_Settings_Privacy',
  props: ['user'],
  components: {
    FormChangePassword,
    FormAlternativeEmail
  },
  data () {
    return {
      errors: []
    }
  },
  methods: {
    // PREREQUISITES
    showFormChangePassword: function () {
      this.$refs['pw-form'].show()
    },
    showFormAltEmail: function () {
      this.$refs['ae-form'].show()
    }
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MyAccount/Settings/Privacy/Privacy.vue